var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-settings__block"},[_c('p',{staticClass:"text text--instruction"},[_vm._v(" URL DE VOTRE SITE ")]),_c('WebsiteLink',{attrs:{"url":_vm.formattedDomainName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }